// extracted by mini-css-extract-plugin
export default {"logContainer":"DealTermsLog_logContainer__t7eON"};